import script from "./StockJpManual.vue?vue&type=script&lang=ts&setup=true"
export * from "./StockJpManual.vue?vue&type=script&lang=ts&setup=true"

import "./StockJpManual.vue?vue&type=style&index=0&id=56ac228a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ac228a"]])

export default __exports__